import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';
import GlobalStyles from './GlobalStyles';
import Home from './pages/Home';
import About from './pages/About';
import Personal from './pages/Personal';
import Business from './pages/Business';
import Loans from './pages/Loans';
import Careers from './pages/Careers';
import HelpCentre from './pages/HelpCentre';
import PrivacyPolicy from './pages/privacypolicy'; // Import the Privacy Policy page
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppWidget from './components/WhatsAppWidget';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles />
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/personal" element={<Personal />} />
          <Route path="/business" element={<Business />} />
          <Route path="/loans" element={<Loans />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/help-centre" element={<HelpCentre />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} /> {/* Add this route */}
        </Routes>
        <Footer />
        <WhatsAppWidget />
      </Router>
    </ThemeProvider>
  );
}

export default App;